import { render, staticRenderFns } from "./ThisFooter.vue?vue&type=template&id=3143bb4c&scoped=true"
import script from "./ThisFooter.vue?vue&type=script&lang=js"
export * from "./ThisFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143bb4c",
  null
  
)

export default component.exports